import About from './About';
const siteTitle = 'test';

const AboutRoutes = {
		about: {
				path: '/About/',
				label: 'About',
				title: `${siteTitle} - About`,
				component: About
		}
};

export { AboutRoutes, About };



// WEBPACK FOOTER //
// ./src/app/containers/About/index.ts